import type { ApiResponse } from "@/models/api-response";

export function getListItems<T>(response: ApiResponse<T[]> | T[] | null | undefined): T[] {
  if (!response) {
    return [];
  }

  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response.data)) {
    return response.data;
  }

  return [];
}
